import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_PRODUCT } from "../product.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateProductInput } from "../../../__generated__/globalTypes";
import {
  CreateProductMutation,
  CreateProductMutationVariables,
} from "../../../__generated__/CreateProductMutation";

interface IProps {
  defaultValues: DeepPartial<CreateProductInput>;
  onCompleted: () => any;
}

export const useCreateProduct = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateProductInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateProductMutation,
    CreateProductMutationVariables
  >(CREATE_PRODUCT, {
    refetchQueries: ["ProductsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createProduct?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createProduct?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
